<template>
    <div>
        <form class="myForm mt-5">
            <div class="form-group row">
                <label for="nome" class="col-sm-2 col-form-label">Descrição: <span class='text-danger'> *</span></label>
                <div class="col-sm-5">
                    <input type="text" class="form-control" v-model="desc" required>
                </div>
            </div>

            <div class="form-group row">
                <label for="staticEmail" class="col-sm-2 col-form-label">Ícone: <span
                        class='text-danger'> * </span></label>
                <div class="col-sm-5">
                    <i :class="'fas fa-' + icone"></i>
                    <font-awesome-picker v-on:selectIcon="iconeFuncao" seachbox="Selecione o ícone desejado" required
                                         v-model="icone"></font-awesome-picker>
                </div>
            </div>
        </form>
        <div class="container text-right mt-2">
            <button class="btn btn-sm btn-danger" @click="retorno">Retornar</button>
            <button class="btn btn-sm btn-success ml-2" :disabled="(!desc != '' || !icone != '')" @click="salvar">
                Salvar
            </button>
        </div>
    </div>
</template>

<script>
    import MenuInternoCadastros from '../menu-interno/MenuInternoCadastros.vue'
    import {fontAwesomePicker} from 'font-awesome-picker'

    export default {
        name: 'TipoObrasEditar',
        props: {
            id: Number
        },
        data() {
            return {
                icone: '',
                desc: ''
            }
        },
        components: {
            MenuInternoCadastros,
            'font-awesome-picker': fontAwesomePicker
        },
        methods: {
            retorno() {
                this.$router.go(0)
            },
            salvar() {
                API.enviarRequisicao('put', '/api/sist-obras/tipo-obras/' + this.id, {
                    c01_descr: this.desc,
                    c01_icone: this.icone
                })
                    .then(response => {
                        this.$swal('Parabéns!', 'Dados salvos com sucesso.', 'success')
                            .then(
                                function () {
                                    history.go(0);
                                }
                            )

                    })
                    .catch(function (error) {
                        this.$swal('Atenção!', 'Erro ao cadastrar os dados.', 'error')
                    })
            },
            iconeFuncao(selectedIcon) {
                this.icone = selectedIcon.className
            }
        },
        mounted: function () {
            API.enviarRequisicao('get', '/api/sist-obras/tipo-obras/' + this.id)
                .then(response => {
                    this.desc = response.data.c01_descr,
                        this.icone = response.data.c01_icone
                })
        }

    }
</script>


<style scoped>
    .salvar {
        background-color: #18A689;
        color: #fff;
        font-size: 12px;
        text-decoration: none;
    }
</style>
